export default __webpack_public_path__ + "static/media/graphics-noinfofound.1a0f74f7.png";